import {
  PublicationSearchResult,
  PublicationSearchResultTemplateName,
  PublicationSearchResultProps,
} from './publication-search-result/publication-search-result';

import {
  TitleWithDescriptionProps,
  TitleWithDescriptionTemplateName,
  TitleWithDescription,
} from './title-with-description/title-with-description';

/**
 * Multiple templates can be defined
 *
 * Each template has:
 *  - a type for its props (should match the data contract for a result from the endpoint)
 *  - a string representing a "name" for the template
 *  - a jsx template for the actual markup
 *
 */

export type AafpFilteredSearchResult = PublicationSearchResultProps | TitleWithDescriptionProps;

export type AafpFilteredSearchTemplateName = PublicationSearchResultTemplateName | TitleWithDescriptionTemplateName;

export const templates = {
  PublicationSearchResult,
  TitleWithDescription,
};
